import React from 'react'
import { useSelector } from 'react-redux'
import { Box } from '@material-ui/core'

import { messageSelectors } from '../../store/messages'

export const TriggerText = () => {
	const lastUnreadTrigger = useSelector(messageSelectors.lastUnreadTriggerMessage)

	return (
		<Box
			mx={2}
			mt={1}
			mb={2}
			maxHeight={105}
			maxWidth={200}
			overflow="hidden"
			textOverflow="ellipsis"
			data-testid="triggerMessage"
		>
			{lastUnreadTrigger.content?.text}
		</Box>
	)
}
